// Material Dashboard 2 React helper functions
import pxToRem from "../../functions/pxToRem";
import typography from "../../base/typography";

const { size } = typography;

const dialogTitle = {
  styleOverrides: {
    root: {
      padding: pxToRem(16),
      fontSize: size.xl,
    },
  },
};

export default dialogTitle;
